import { DoqLayout, DoqSize } from './types';

export const getSpeechBubbleSize = (layout: DoqLayout = DoqLayout.PAGE) => {
  switch (layout) {
    case DoqLayout.DIALOG:
      return { height: 48, width: 261 };
    case DoqLayout.VERTICAL:
      return { height: 107, width: 480 };
    case DoqLayout.PAGE:
      return { height: 107, width: 592 };
  }
};

export const getSpeechBubblePath = (layout: DoqLayout = DoqLayout.PAGE) => {
  switch (layout) {
    case DoqLayout.DIALOG:
      return 'M8 0a8 8 0 00-8 8v20c0 .27.013.537.04.8H0v17.26a1.8 1.8 0 003.278 1.028L10.99 36H253a8 8 0 007.996-7.75L261 28V8a8 8 0 00-8-8z';
    case DoqLayout.VERTICAL:
      return 'M16 0C7.1634 0 0 7.1634 0 16v48c0 8.8366 7.1634 16 16 16h206.51l-.0002 22.249c0 2.2092 1.7908 4 4 4a4 4 0 003.2832-1.7152L246.866 80H464c8.7314 0 15.8292-6.9939 15.997-15.6851L480 64V16c0-8.8366-7.1634-16-16-16z';
    case DoqLayout.PAGE:
      return 'M0 102.25a4 4 0 007.283 2.284L24.355 80H576c8.731 0 15.83-6.994 15.997-15.685L592 64V16c0-8.837-7.163-16-16-16H16C7.163 0 0 7.163 0 16v86.25z';
  }
};

export const getDoqSizeForLayout = (layout: DoqLayout = DoqLayout.PAGE) => {
  switch (layout) {
    case DoqLayout.DIALOG:
      return DoqSize.SMALL;
    case DoqLayout.VERTICAL:
      return DoqSize.MEDIUM;
    case DoqLayout.PAGE:
      return DoqSize.BIG;
  }
};

export const isDoqLayout = (
  doqLayout: string
): doqLayout is keyof typeof DoqLayout =>
  Object.values<string>(DoqLayout).includes(doqLayout);

export const getDashboardDoqSize = (): DoqSize =>
  window.innerWidth <= 1440 ? DoqSize.EXTRA_SMALL : DoqSize.SMALL;
